<template>    
  <div class="content">
 
    <b-container fluid >
      <div>
        <card class="no-border-card" body-classes=" p-4" footer-classes="pb-2">

          <b-row class="justify-content-md-center" align-v="center" >
            <b-col>
              <h1 class="mb-0">Survey Questions</h1>
            </b-col>
            <b-col class="float-right">
              <base-button icon type="success" class="float-right"  @click="toggle_new_survey_question_modal" >
                <span class="btn-inner--icon"><i class="ni ni-collection"></i></span>
                <span class="btn-inner--text">Create Survey Question</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- survey_question table -->
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2" v-if="$parent.survey_questions.length > 0">
        
            <ve-table :columns="columns" :table-data="tableData"  :fixed-header="true" ref="survey_questions_table"></ve-table> <!--:sort-option="sortOption"-->
             <div class="table-pagination mt-3">
                <ve-pagination
                    :total="totalCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
          
        </card>
        <!-- survey_question table -->

      </div>

      <!-- new survey_question modal -->
      <div>
      
        <modal :show.sync="modals.new_survey_question.show_modal" class="modal-xl" body-classes="p-0" id="new_survey_question_modal" ref="new_survey_question_modal" >


          <card
            header-classes="bg-transparent pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

            <div class="text-muted text-center mt-2 mb-3">
              <h2>Create New Survey Question</h2>
            </div>

            <div v-if="modals.new_survey_question.errors.length > 0">
              <b-alert show variant="danger" v-for="new_survey_question_errors in modals.new_survey_question.errors" :key="new_survey_question_errors"
                              :error_text="new_survey_question_errors" >
                <strong>{{new_survey_question_errors}}</strong>
              </b-alert>
            </div>

            <b-form role="form">


              <base-input alternative
                          v-model="modals.new_survey_question.form_data.survey_question_name"
                          class="mb-3"
                          placeholder="Survey Question Name"
                          prepend-icon="drive_file_rename_outline">
              </base-input>

              <base-input alternative
                          v-model="modals.new_survey_question.form_data.survey_question_placeholder"
                          class="mb-3"
                          placeholder="Short Title"
                          prepend-icon="subtitles">
              </base-input>

          
              
              <form>
                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_survey_question.form_data.is_active"></base-switch>
                </b-form-group>
              </form>

              <base-input label="Question Type">
                <el-select v-model="modals.new_survey_question.form_data.input_type">
                  <el-option v-for="input_type in this.survey_question_options.input_types"
                            :key="input_type"
                            :label="input_type"
                            :value="input_type">
                  </el-option>
                </el-select>
              </base-input>

              <base-input label="Script Association">
                <el-select v-model="modals.new_survey_question.form_data.script_uuids" filterable multiple >
                    <el-option v-for="script in $parent.scripts" 

                            :key="script.script_uuid"
                            :label="script.script_name"
                            :value="script.script_uuid"
                            v-b-tooltip.hover.top :title="script.script_text_fallback"
                    >
                  </el-option>
                </el-select>
              </base-input>

              

            </b-form>

          </card>

          <template slot="footer">
            <base-button type="danger" @click="close_new_survey_question_modal()">Cancel</base-button>
            <base-button type="success" @click="next_survey_question_modal()">Next</base-button>
          </template>

        </modal>
        <modal :show.sync="modals.new_survey_question.show_modal_two" class="modal-xl" body-classes="p-0" id="new_survey_question_modal_two" ref="new_survey_question_modal_two" >
          <card
            header-classes="bg-transparent pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0 mb-0">

            <div v-if="modals.new_survey_question.errors.length > 0">
              <b-alert show variant="danger" v-for="new_survey_question_errors in modals.new_survey_question.errors" :key="new_survey_question_errors"
                              :error_text="new_survey_question_errors" >
                <strong>{{new_survey_question_errors}}</strong>
              </b-alert>
            </div>

            <div class="text-muted text-center mt-2 mb-3">
              <h2>Form Options</h2>
            </div>

            <div class="input_options_contain">
                <div v-if="modals.new_survey_question.form_data.input_type === 'text'">
                  
                  <h3>Optional Fields:</h3>
                  <p>Material Icon String</p>
                  <base-input alternative
                    v-model="modals.new_survey_question.form_data.input_icon_string"
                    class="mb-3"
                    placeholder="speaker_notes"
                    prepend-icon="wallpaper">
                 </base-input>

                 <p>Pre written handlebars</p>
                  <base-input alternative
                    v-model="modals.new_survey_question.form_data.input_render_value_handlebars"
                    class="mb-3"
                    :placeholder="modals.new_survey_question.input_render_value_handlebars_placeholder"
                    prepend-icon="code">
                 </base-input>

                </div>
                <div v-else-if="modals.new_survey_question.form_data.input_type === 'textarea'">

                  <h3>Optional Fields:</h3>
                  <p>Pre written handlebars</p>
                  <base-input alternative
                    v-model="modals.new_survey_question.form_data.input_render_value_handlebars"
                    class="mb-3"
                    :placeholder="modals.new_survey_question.input_render_value_handlebars_placeholder"
                    prepend-icon="code">
                  </base-input>

                  <p>Rows</p>
                  <base-input type="number" placeholder="3" v-model="modals.new_survey_question.form_data.input_rows"  />

                  <p>Max Rows</p>
                  <base-input type="number" placeholder="3" v-model="modals.new_survey_question.form_data.input_max_rows"  />
                  
                </div>

                <div v-else-if="modals.new_survey_question.form_data.input_type === 'multi_select'">
                  <p>Type value and hit enter.</p>
                  <tags-input v-model="these_input_values" placeholder="Type Value, Hit Enter" class="test"></tags-input>
                </div>
                
                <div v-else-if="modals.new_survey_question.form_data.input_type === 'checkbox'">
                  <form>
                    <b-form-group label="Pre Checked" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                      <base-switch class="mr-1" v-model="modals.new_survey_question.form_data.input_checked_default"></base-switch>
                    </b-form-group>
                  </form>

                  <base-input alternative
                          v-model="modals.new_survey_question.form_data.input_checked_value"
                          class="mb-3"
                          placeholder="Checked Value"
                          prepend-icon="drive_file_rename_outline">
                  </base-input>

                  <base-input alternative
                          v-model="modals.new_survey_question.form_data.input_unchecked_value"
                          class="mb-3"
                          placeholder="Un Checked Value"
                          prepend-icon="drive_file_rename_outline">
                  </base-input>

                </div>
                <div v-else-if="modals.new_survey_question.form_data.input_type === 'range'">

                  <p>Minimum</p>
                  <base-input alternative
                          v-model="modals.new_survey_question.form_data.input_min_name"
                          class="mb-3"
                          placeholder="Left Text"
                          prepend-icon="arrow_back">
                  </base-input>
                  <base-input type="number" placeholder="3" v-model="modals.new_survey_question.form_data.input_min"  />

                  <p>Maximum</p>
                  <base-input alternative
                          v-model="modals.new_survey_question.form_data.input_max_name"
                          class="mb-3"
                          placeholder="Right Text"
                          prepend-icon="arrow_forward">
                  </base-input>
                  <base-input type="number" placeholder="3" v-model="modals.new_survey_question.form_data.input_max"  />
                </div>
                <div v-else-if="modals.new_survey_question.form_data.input_type === 'dropdown'">
                  <h3>Drop Down Values</h3>
                  <p>Keep them short & simple. <i>Yes, No, Not Attending.</i></p>
                  <tags-input v-model="these_input_values" placeholder="Type Value, Hit Enter" class="test"></tags-input>

                  <p>Material Icon String</p>
                  <base-input alternative
                          v-model="modals.new_survey_question.form_data.input_icon_string"
                          class="mb-3"
                          placeholder="event"
                          prepend-icon="wallpaper">
                  </base-input>
                  
                </div>
            </div>  

            <div class="form_preview_contain">
              <h3>Preview:</h3>
              <p><b>{{this.modals.new_survey_question.form_data.survey_question_name}}</b></p>

              <div v-if="modals.new_survey_question.form_data.input_type === 'text'">
                <base-input v-if="modals.new_survey_question.form_data.input_render_value_handlebars"
                    :placeholder="modals.new_survey_question.form_data.input_render_value_handlebars"
                    :name="modals.new_survey_question.form_data.survey_question_uuid"
                    class="full-width" 
                    :prepend-icon="modals.new_survey_question.form_data.input_icon_string"
                />
                <base-input v-else
                    placeholder="Answer Here"
                    :name="modals.new_survey_question.form_data.survey_question_uuid"
                    class="full-width" 
                    :prepend-icon="modals.new_survey_question.form_data.input_icon_string"
                />
              </div>


              <div v-if="modals.new_survey_question.form_data.input_type === 'textarea'">
                  <b-form-textarea v-if="modals.new_survey_question.form_data.input_render_value_handlebars"
                      :placeholder="modals.new_survey_question.form_data.input_render_value_handlebars"
                      class="full-width" 
                      :rows="modals.new_survey_question.form_data.input_rows"
                      :max-rows="modals.new_survey_question.form_data.input_max_rows"
                  >
                  </b-form-textarea>
                  <b-form-textarea v-else
                      placeholder="Answer Here"
                      class="full-width" 
                      :rows="modals.new_survey_question.form_data.input_rows"
                      :max-rows="modals.new_survey_question.form_data.input_max_rows"
                  >
                  </b-form-textarea>
              </div>

              <div v-else-if="modals.new_survey_question.form_data.input_type === 'multi_select'" class="survey_question_multi_select_contain">
                <base-input label="Multiple select">
                    <el-select v-model="multi_test"
                                multiple
                                filterable
                                placeholder="Multiple select">
                        <el-option v-for="(value) in this.modals.new_survey_question.form_data.input_values"
                                :key="value"
                                :label="value"
                                :value="value">
                        </el-option>
                    </el-select>
                </base-input>
              </div>

              <div v-else-if="modals.new_survey_question.form_data.input_type === 'checkbox'" class="survey_question_checkbox_contain">
                  
                  <b-form-checkbox
                      class="full-width"
                      :placeholder="modals.new_survey_question.form_data.survey_question_placeholder"
                      :checked="modals.new_survey_question.form_data.input_checked_default"
                      :unchecked-value="modals.new_survey_question.form_data.input_unchecked_value"
                  >
                  <p>{{this.modals.new_survey_question.form_data.survey_question_placeholder}}</p>
                  </b-form-checkbox>
              
              </div>

              <div v-else-if="modals.new_survey_question.form_data.input_type === 'dropdown'" class="survey_question_dropdown_contain">
              
                      <b-dropdown variant="default" class="" id="inactive_sc_btn_2">
                          <template v-slot:button-content>
                              <span v-if="modals.new_survey_question.form_data.input_icon_string" class="material-icons material-icons-outlined">{{modals.new_survey_question.form_data.input_icon_string}}</span> {{modals.new_survey_question.form_data.survey_question_placeholder}}
                          </template>
                          <b-dropdown-item v-for="(value) in this.modals.new_survey_question.form_data.input_values"
                          :key="value">
                            {{value}}
                          </b-dropdown-item>
                      </b-dropdown>
              
              </div>

              <div v-else-if="modals.new_survey_question.form_data.input_type === 'range'" class="survey_question_range_contain">


                  <div class="range_label_contain">
                      <div class="range_label_left">
                          <p>Strong {{modals.new_survey_question.form_data.input_min_name}}</p>
                      </div>
                      
                      <div class="range_label_right">
                          <p>Strong {{modals.new_survey_question.form_data.input_max_name}}</p>
                      </div>
                      <div style="clear:both;"></div>
                  </div>
                  <div class="styled_range_input_contain">
                      <input type="range"
                      v-model=range_test
                      :min=modals.new_survey_question.form_data.input_min
                      :max=modals.new_survey_question.form_data.input_max steps="1"

                      class="gradient-range" >
                  </div>
                  <div style="clear:both;"></div>
                  <div class="range_label_center">
                      <p>{{range_test}}</p>
                  </div>
              </div>
            </div>

          </card> 
          <template slot="footer">
            <base-button type="danger" @click="close_new_survey_question_modal()">Cancel</base-button>
            <base-button type="success" @click="submit_new_survey_question()" :disabled="modals.new_survey_question.is_busy" ref="create_survey_question_button">Create Survey Question <i v-if="modals.new_survey_question.is_busy" class="fas fa-spinner fa-spin"></i> </base-button>
          </template>
        </modal>
      </div>

      <!-- edit scripts modal -->
      <div>
        <modal :show.sync="edit_scripts_modal.show_modal" class="modal-xl" body-classes="p-0" id="edit_scripts_modal" ref="edit_scripts_modal">
          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Edit Attached Scripts</h2>
                <p>{{edit_scripts_modal.survey_question_name}}</p>
              </div>

              <b-form role="form">
                <base-input label="Scripts">
                  <el-select v-model="edit_scripts_modal.script_uuids"
                            multiple
                            filterable
                            >
                    <el-option v-for="scripts in $parent.scripts"
                              :key="scripts.script_uuid"
                              :label="scripts.script_name"
                              :value="scripts.script_uuid">
                    </el-option>
                  </el-select>
                </base-input>
              </b-form>
          </card>

          
      

         <template slot="footer">
            <base-button type="danger" @click="close_edit_scripts_modal()">Cancel</base-button>
            <base-button type="success" @click="edit_scripts_send()" :disabled="edit_scripts_modal.is_busy" ref="edit_scripts_button">Update Scripts <span v-if="edit_scripts_modal.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          </template>
        </modal>
      </div>
      <!-- end edit scripts modal -->


    </b-container>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui';

import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'
import helpers from '@/util/helpers.js'
import TagsInput from '@/components/Inputs/TagsInput'

//import TagsInput from '@/components/Inputs/TagsInput'

import VueEasytable  from "vue-easytable";
import moment from 'moment'

export default {
  components: {
    VueEasytable,
    BModal,
    TagsInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      //new tables
      pageIndex: 1,
      pageSize:10,

      columns: [
        {
            field: "survey_question_name",
            key: "survey_question_name",
            title: "Name",
            width:120,
            align: "left",
            renderBodyCell: ({ row, column, index }, h) => {
              if(!row.date_created) {
                return <div>{row.survey_question_name}</div>
              } else {
                return (
                  <div v-b-tooltip={moment(row.date_created).format('MM/DD/YYYY')}>{row.survey_question_name}</div>
                )
              }
            }
           // sortFn:this.sortChange,
            
        },{
            field: "date_created",
            key: "date_created",
            title: "Date",
            width: 90,
            align: "left",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              if(!row.date_created) {
                 return
               } else {
                 return moment(row.date_created).format('MM/DD/YYYY');
               }
            }
        },
        {
            field: "is_active",
            key: "is_active",
            title: "Active",
            align: "left",
            width: 80,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              let real_row_index
              if(this.pageIndex === 1) {
                real_row_index = ++rowIndex
              } else {
                rowIndex = rowIndex +1
                real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
              }
      
              return (
              
                <div slot-scope="{real_row_index, row}" class="d-flex" >
                  <base-switch class="mr-1" v-model={this.$parent.survey_questions[real_row_index-1].is_active}  onTrigger_function={() => this.change_this_list((real_row_index-1),this.$parent.survey_questions[real_row_index-1])}  ></base-switch> 
                </div>
                
              )
              
            }
        },
         {
          field: "scripts_edit",
          key: "scripts_edit",
          title: "Scripts",
          width: 150,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let real_row_index
            if(this.pageIndex === 1) {
              real_row_index = ++rowIndex
            } else {
              rowIndex = rowIndex +1
              real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
            }

            let number_scripts = 0
            let this_scripts_pill_width = 'padding-left: 0.875em;padding-right: 0.875em;'
            let calculate_scripts_pill_ratio = .875
            if(typeof row !== 'undefined' && typeof row.script_uuids !== 'undefined') {
              if(row.script_uuids.length && row.script_uuids.length > 0)  {
                number_scripts= row.script_uuids.length
                calculate_scripts_pill_ratio = calculate_scripts_pill_ratio + ((calculate_scripts_pill_ratio/3)*number_scripts)
                this_scripts_pill_width = 'padding-left: '+calculate_scripts_pill_ratio+'em;padding-right: '+calculate_scripts_pill_ratio+'em;'

              }
            }

            return (
              <div>
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center " onClick={() => this.edit_scripts((real_row_index-1),row)}>
                    Scripts 
                    <b-badge variant="primary" pill style={this_scripts_pill_width} class="left_5px">{number_scripts}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </div>
            )
            
          }
        },
        {
          field: "download",
          key: "download",
          title: "",
          width: 30,
          align: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('survey_questions:answers_read')  ) {
              if(this.$parent.active_user.admin !== true) {
                return
              }
            } 

            let real_row_index
            if(this.pageIndex === 1) {
              real_row_index = ++rowIndex
            } else {
              rowIndex = rowIndex +1
              real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
            }

            let button_id = "download_sc_button_"+real_row_index
            return (
              <base-button
                onClick={() =>
                  this.download_survey_question_responses(real_row_index-1, row,button_id)
                }
               
                class="btn-link"
                type="success"
                size="sm"
                id={button_id}
                icon
              >
              
                <span class="material-icons material-icons-outlined color-white">cloud_download</span>
              </base-button>
            )
           
          }
        }

        


      ],
      sortOption: {
          //multipleSort: true,
          sortChange: (params) => {
              console.log("sortChange::", params);
              this.sortChange(params);
          },
      },
      edit_scripts_modal: {
        show_modal:false,
        is_busy:false,
        script_uuids: [],
        index:null,
        survey_question_name: null
      },


      is_inside_change_data_callback: false,
      changed_row_index_numbers: [],
      range_test: 3,
      multi_test: null,
      survey_question_options: {
        input_types: ['text','textarea','dropdown','checkbox','range','multi_select'],
      },
      these_input_values: [],
      modals: {
        new_survey_question: {
          show_modal: false,
          show_modal_two: false,
          is_busy: false,
          errors: [

          ],
          input_render_value_handlebars_placeholder: 'Hi, {{active_user.first_name}}',
          current_input_type: 'text',
          default_form_data: {
            "org_id":this.$parent.active_org.org_id,
            script_uuids:[],
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            survey_question_name: null,
            survey_question_placeholder: null,
            input_type: 'text',
            survey_question_data_type: null,
            input_icon_string: null,
            input_values: [],
            input_checked_default: false,
            input_unchecked_value: null,
            input_checked_value: null,
            input_min: 0,
            input_max: 5,
            input_min_name: null,
            input_max_name: null,
            input_max_rows: 5,
            input_rows: 3,
            input_render_value_handlebars: null,
            survey_question_form_id: this.generate_survey_question_form_id,
            input_required: true,
            "is_active":true
            
          },
          form_data: {
            "org_id":this.$parent.active_org.org_id,
            script_uuids: [],
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            survey_question_name: null,
            survey_question_placeholder: null,
            input_type: 'text',
            survey_question_data_type: null,
            input_icon_string: null,
            input_values: [],
            input_checked_default: null,
            input_unchecked_value: null,
            input_checked_value: null,
            input_min: null,
            input_max: null,
            input_min_name: null,
            input_max_name: null,
            input_max_rows: null,
            input_rows: null,
            input_render_value_handlebars: null,
            survey_question_form_id: this.generate_survey_question_form_id,
            input_required: true,
            "is_active":true
          }
        }
      }
    };
  },
  computed: {
    totalCount() {
        return this.$parent.survey_questions.length || 0
    },
    tableData() {
      this.$parent.update_backdoor
      const { pageIndex, pageSize } = this;
      return this.$parent.survey_questions.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    generate_survey_question_form_id: function() {
      if(this.modals.new_survey_question.form_data.survey_question_placeholder && this.modals.new_survey_question.form_data.survey_question_placeholder!== null && this.modals.new_survey_question.form_data.survey_question_placeholder!== '') {
        return 'sc_input_'+this.modals.new_survey_question.form_data.survey_question_placeholder.toLowerCase().replace(/\s/g, '').replace(/[^a-zA-Z]+/g, '')
      } else {
        return 'sc_input_'+helpers.make_simple_rand_string(10,true,false,true,false)//length,alpha,numbers,lower_only,symbols
      }
    }
  },
  watch: {
     these_input_values: {
        handler: function(newVal,oldVal) {

          if(newVal && newVal !== null && newVal.length && newVal.length > 0) {
            
            if(newVal.length>4) {
              swal.fire({
                title: `Only 4 Values`,
                text: 'Please only enter 4 values. Contact admin if you need more',
                buttonsStyling: false,
                icon: 'warning'
              })
              modals.new_survey_question.form_data.input_values.pop()
            } else {
             
              //make sure no dupes
              let has_dupe = false
              //console.log(newVal.at(-1))

              
                if(this.modals.new_survey_question.form_data.input_values.includes(newVal.at(-1))) {
                  has_dupe = true
                  
                  swal.fire({
                    title: `Don't Repeat Values`,
                    buttonsStyling: false,
                    icon: 'warning'
                  })
                }
              
              if(has_dupe === false) {
                this.modals.new_survey_question.form_data.input_values = newVal
              } else {
                let new_array = newVal.pop()
                this.modals.new_survey_question.form_data.input_values = new_array
              }
            }
          }
          
        }
      },
  },
  created() {
    window.addEventListener("resize", this.window_resize_function);
    this.window_resize_function()
  },
  destroyed() {
    window.removeEventListener("resize", this.window_resize_function);
  },
  methods: {
    calculate_window_width() {
      var this_width = 0
      if( typeof( window.innerWidth ) == 'number' ) {
        //Non-IE
        this_width = window.innerWidth;
      } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
        //IE 6+ in 'standards compliant mode'
        this_width = document.documentElement.clientWidth;
      } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
        //IE 4 compatible
        this_width = document.body.clientWidth;
      }
      return this_width
    },
    //mobile hide date i think
    window_resize_function(event) {
      //if(event.type && event.type === 'resize') {
        let this_width =  this.calculate_window_width() 

        if(this_width <= 600) {
          this.hideColumns(['date_created'],'survey_questions_table')
        } else {
          this.showColumns(['date_created'],'survey_questions_table')
        } 
      //}
    },
    hideColumns(keys,table_ref) {
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }

      //make sure element exists
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].hideColumnsByKeys(keys);
        }
      })
      
    },
    // show cloumns
    showColumns(keys,table_ref) {   //array, ref
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].showColumnsByKeys(keys)
        }
        
      })
    },
    pageNumberChange(pageIndex) {
        this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
        this.pageIndex = 1;
        this.pageSize = pageSize;
    },

    sortChange(params) {

      console.log('debug sortChange ')
      console.log(params)
      let data = this.tableData.slice(0);

      data.sort((a, b) => {
          if (params.survey_question_name) {
              if (params.survey_question_name === "asc") {
                  return a.survey_question_name - b.survey_question_name;
              } else if (params.survey_question_name === "desc") {
                  return b.survey_question_name - a.survey_question_name;
              } else {
                  return 0;
              }
          } else  if (params.org_id) {
              if (params.org_id === "asc") {
                  return a.org_id - b.org_id;
              } else if (params.org_id === "desc") {
                  return b.org_id - a.org_id;
              } else {
                  return 0;
              }
          } else if (params.date_created) {
            console.log('date_created sort')
            if (params.date_created === "asc") {
                return a.date_created - b.date_created;
            } else if (params.date_created === "desc") {
                return b.date_created - a.date_created;
            } else {
                return 0;
            }

          }
      });

      this.tableData = data;
    },
    fire_swal_error(message) {

      return swal.fire({
        title: `Warning`,
        text: message+'',
        buttonsStyling: false,
        icon: 'warning'
      })
    
    },
    download_survey_question_responses(index,row,button_id) {
      try {

      

        if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('survey_questions:answers_read')  ) {
          if(this.$parent.active_user.admin !== true) {
            return this.fire_swal_error('No permission to download')
          }
        }

        console.log('download survey questions index ' + index)
        console.log(JSON.stringify(row))
        console.log(JSON.stringify(this.$parent.survey_questions[index]))
        console.log(button_id)

        //make sure aligns right now they dont
        if(row.survey_question_uuid !== this.$parent.survey_questions[index].survey_question_uuid) {
          console.log('state error survey question download doesnt match parent?')
          console.log('download survey questions index ' + index)
          console.log(JSON.stringify(row))
          console.log(JSON.stringify(this.$parent.survey_questions[index]))
          return this.fire_swal_error('Download error. Contact admin.')
        }

        

        let this_download_url = 'https://'+this.$parent.use_this_api_domain+'/survey_questions/download/answers?'

        if(row.org_id !== null) {
          this_download_url = this_download_url+'org_id='+row.org_id
        } else {
          console.log('missing org_id ?')
          return this.fire_swal_error('Download error. Contact admin.')
        }

        if(this.$parent.active_user.user_uuid!== null) {
          this_download_url = this_download_url+'&user_uuid='+this.$parent.active_user.user_uuid
        } else {
          console.log('missing user_uuid ?')
          return this.fire_swal_error('Download error. Contact admin.')
        }

        if(row.survey_question_uuid !== null) {
          this_download_url = this_download_url+'&survey_question_uuid='+row.survey_question_uuid
        } else {
          console.log('missing survey_question_uuid ?')
          return this.fire_swal_error('Download error. Contact admin.')
        }

      
        this_download_url = this_download_url+'&jwt='+ this.$parent.active_user_jwt
        
        const link = document.createElement('a');
        link.href = this_download_url;
        link.target = '_blank'
        document.body.appendChild(link);
        link.click();

      } catch(e) {
        console.log('download survey question responses error')
        console.log(e)
        return this.fire_swal_error('Download error. Contact admin.')
      }
    },
    edit_scripts(index,row) {
      try {

        console.log(JSON.stringify(row))
        console.log(JSON.stringify(this.$parent.survey_questions[index]))
        console.log(index)
        //check state is not messed up
        if(row.survey_question_name.toUpperCase() !== this.$parent.survey_questions[index].survey_question_name.toUpperCase()) {
          console.log('state does not align?')

          return this.close_edit_scripts_modal('State mismatch error. refresh and contact admin')          
        }

        //set the current state
        this.edit_scripts_modal.script_uuids = this.$parent.survey_questions[index].script_uuids
        this.edit_scripts_modal.index = index
        this.edit_scripts_modal.survey_question_name = this.$parent.survey_questions[index].survey_question_name

        this.edit_scripts_modal.show_modal = true

      } catch(e) {
        console.log(e)
        return this.close_edit_scripts_modal(e)
      }
      
    },
    edit_scripts_send() {
      try {

        //post it here
        //sending
        this.edit_scripts_modal.is_busy = true

        //update the parent
        this.$parent.survey_questions[this.edit_scripts_modal.index].script_uuids = this.edit_scripts_modal.script_uuids
        this.$parent.survey_questions[this.edit_scripts_modal.index].last_modified = new Date().getTime()
        this.$parent.survey_questions[this.edit_scripts_modal.index].user_uuid_last_modified = this.$parent.active_user.user_uuid

        axios.post('https://'+this.$parent.use_this_api_domain+'/survey_questions/question', this.$parent.survey_questions[this.edit_scripts_modal.index], {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then((result,error) => {
          if(result) {
            this.$parent.survey_questions[this.edit_scripts_modal.index] = result.data
            this.close_edit_scripts_modal()
          }
          if(error) {
            console.log('debug update survey question error ')
            console.log(JSON.stringify(error))
            return this.close_edit_scripts_modal(error)
          }

        })
        .catch((error) => {
          if(error){
            console.log(error)
          }
          return this.close_edit_scripts_modal(error || 'error updating survey question scripts')
        })
        
      } catch(e) {
        console.log(e)
        return this.close_edit_scripts_modal(e)
      }
    },
    close_edit_scripts_modal(send_error) {
      this.$parent.update_backdoor = this.$parent.update_backdoor + 1

      if(typeof send_error !== 'undefined' && send_error !== null) {
        return swal.fire({
          title: `Warning`,
          text: send_error,
          buttonsStyling: false,
          icon: 'warning'
        })
      }

      //reset on done
      this.edit_scripts_modal.is_busy = false
      this.edit_scripts_modal.index = null
      this.edit_scripts_modal.show_modal = false
      this.edit_scripts_modal.script_uuids = []
      this.edit_scripts_modal.survey_question_name = null
    },





    change_this_survey_question: function(index,row) {
      this.$nextTick(function () {
        if(!this.changed_row_index_numbers.includes(index)) {
          this.changed_row_index_numbers.push(index)
          this.post_updated_row_data(index,row)
        }
      })
    },
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_updated_row_data: function(index,row) {
      //let this_row_elements = document.getElementsByClassName("el-table__row")
      //this_row_elements[index].classList.add("table_row_loading");
      

    //TODO is_active bug? i dont know why the status is backwards/not showing in row but it is in the actual parent update
      setTimeout(() => {
        //there is a timing bug vue is fucked?
        console.log('debug new row')
        console.log(JSON.stringify(row))
        console.log(JSON.stringify(this.$parent.survey_questions[index]))

       

        try {
          console.log('rows that have been updated ' + JSON.stringify(index))

          let array_of_axios_post_promises = []

          //for (let index = 0; index < this.changed_row_index_numbers.length; index++) {
            //let update_this_survey_question = this.$parent.outbound_survey_questions[index]
            row.user_uuid_last_modified = this.$parent.active_user.user_uuid

            array_of_axios_post_promises.push(
              axios.post('https://'+this.$parent.use_this_api_domain+'/survey_questions/question', this.$parent.survey_questions[index], {
                headers: {
                  'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                }
              })
            )
          //}

          Promise.allSettled(array_of_axios_post_promises)
          .then(result => {
            console.log(result)

          })
          .catch(error => {
            console.log(error)
          })
          .finally(someting => {
            //shuold try to match if an index failed? for now just clear it
            console.log('finally')
            //this_row_elements[index].classList.remove("table_row_loading");
          // this.changed_row_index_numbers = []
            //this.is_inside_change_data_callback = false
            this.removeItemAll(this.changed_row_index_numbers,index)
          })

        } catch(e) {
          console.log(e)
          // console.log('finally')
          // this.changed_row_index_numbers = []
          // this.is_inside_change_data_callback = false
          this.removeItemAll(this.changed_row_index_numbers,index)
        }

      }, 200);

    },
    toggle_new_survey_question_modal: function() {
      this.modals.new_survey_question.show_modal = true
      //this.$refs['new_survey_question_modal'].toggle('#toggle_new_survey_question_modal')
    },
    next_survey_question_modal: function() {
      this.modals.new_survey_question.show_modal = false
      this.modals.new_survey_question.show_modal_two = true
    },
    close_new_survey_question_modal: function() {
      //reset the data
      this.modals.new_survey_question.form_data = this.modals.new_survey_question.default_form_data 

      //clear any erors 
      this.modals.new_survey_question.errors = []
      //close
      this.modals.new_survey_question.show_modal = false
      this.modals.new_survey_question.show_modal_two = false
      this.modals.new_survey_question.is_busy = false

      this.these_input_values = []
      this.multi_test = []

    },
    submit_new_survey_question: function(this_event) {



      
      console.log('submiting this survey_question: ')
      console.log(this.modals.new_survey_question.form_data)

      this.modals.new_survey_question.is_busy = true
      

      //make sure has a few details
      try {
        console.log('debug 739')
        if(!this.modals.new_survey_question.form_data.survey_question_name) {
          this.modals.new_survey_question.errors.push("Must have a survey question name")
        } else  {
          this.modals.new_survey_question.errors = this.modals.new_survey_question.errors.filter(e => e !== "Must have a survey question name")
        }

        if(this.modals.new_survey_question.form_data.survey_question_name && this.modals.new_survey_question.form_data.survey_question_name.length < 7) {
          this.modals.new_survey_question.errors.push("Please write a longer survey question name, at least 8 characters")
        } else {
          this.modals.new_survey_question.errors = this.modals.new_survey_question.errors.filter(e => e !== "Please write a longer survey question name, at least 8 characters")
        }

        if(!this.modals.new_survey_question.form_data.survey_question_placeholder) {
          this.modals.new_survey_question.errors.push("Must have a survey question placeholder")
        } else {
          this.modals.new_survey_question.errors = this.modals.new_survey_question.errors.filter(e => e !== "Must have a survey question placeholder")
        }

        if(this.modals.new_survey_question.form_data.is_active === null) {
          this.modals.new_survey_question.errors.push("Must select active status")
        } else {
          this.modals.new_survey_question.errors = this.modals.new_survey_question.errors.filter(e => e !== "Must select active status")
        }

        //script_uuid
        //CAN be null now
        //if(typeof this.modals.new_survey_question.form_data.script_uuids === 'undefined' || this.modals.new_survey_question.form_data.script_uuids === null ) {
        //  this.modals.new_survey_question.errors.push("Must have a script_uuid association")
        //} else {
        //  this.modals.new_survey_question.errors = this.modals.new_survey_question.errors.filter(e => e !== "Must have a script_uuid association")
        //}



        console.log('debug 771')
      } catch(e) {
        console.log(e)
      }

      console.log('debug 774')

      if(this.modals.new_survey_question.errors.length > 0) {
        //do nothing
        console.log('has errors return')
        this.modals.new_survey_question.is_busy = false
      } else {
        console.log('debug no errors')


        //assign correct survey_question_data_type
        if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'text') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'string'
        } else if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'textarea') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'string'
        } else if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'dropdown') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'string'
        } else if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'range') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'int64'
        } else if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'checkbox') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'string'
        } else if(this.modals.new_survey_question.form_data.input_type && this.modals.new_survey_question.form_data.input_type === 'multi_select') {
          this.modals.new_survey_question.form_data.survey_question_data_type = 'array'
        } else {
          console.log('debug 1143 no type match?')
        }
        //TODO add a timestamp and array option?


        //add the default data from the base
        this.modals.new_survey_question.form_data.org_id =  this.modals.new_survey_question.default_form_data.org_id
        this.modals.new_survey_question.form_data.user_uuid_last_modified =  this.modals.new_survey_question.default_form_data.user_uuid_last_modified
        this.modals.new_survey_question.form_data.user_uuid_created =  this.modals.new_survey_question.default_form_data.user_uuid_created

        //show modal as loading
        this.modals.new_survey_question.is_busy = true

        //make sure has 
        this.modals.new_survey_question.form_data.survey_question_form_id = this.generate_survey_question_form_id

        console.log('debug this.modals.new_survey_question.form_data')
        console.log(JSON.stringify(this.modals.new_survey_question.form_data))
        //post the data
        axios.post('https://'+this.$parent.use_this_api_domain+'/survey_questions/question',  
          this.modals.new_survey_question.form_data, {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then(response => {
          console.log(response)
          if(response.status === 200) {
            //add the returned data (so it has timestamps etc) into the table
            console.log('new survey_question created')
            console.log(response.data)
            this.$parent.survey_questions.unshift(response.data)




          } else {
             swal.fire({
              title: `Warning`,
              text: 'Error creating new survey question',
              buttonsStyling: false,
              icon: 'warning'
            })
            
            console.log(response.data)
          }

        })
        .catch(error =>  {
          swal.fire({
            title: `Warning`,
            text: 'Error creating new survey question',
            buttonsStyling: false,
            icon: 'warning'
          })
          console.log(error.response.data)
        })
        .finally(has_something => {
          console.log('is done posting new survey_question data')

          //
          //close the modal
          //reset the data
          this.close_new_survey_question_modal()

        })
      }

    },

    paginationChanged: function(page) {
      this.pagination.currentPage = page
    },


  }
};


</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
  .table_row_loading {
    opacity: .5;

  }
  div.el-table  .table_row_loading {
    background-color: var(--gray) !important;
  }
  .card .table td, .card .table th, .card .el-table td, .card .el-table th {
    padding-left: 5px;
    padding-right:5px;
  }
  .tags-input__wrapper {
    border: 1px solid var(--gray-300);
    padding: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }
  .el-tag.el-tag--primary {
    margin-right: 10px;
  }
  .tags-input__wrapper input.form-control {
    padding:0px;
     max-width: none;

  }
  .form_preview_contain {
    opacity:0.7;
    padding:8px;
    margin:0px;
    margin-top: 50px;
    border: 1px solid var(--blue-lighter);
  }
  .form_preview_contain p {
    margin-bottom: 5px;

  }
  .form_preview_contain h3 {
    color: var(--blue);
  }
  .form_preview_contain .form-group {
    margin-bottom: 5px;
  }
</style>
